import React from "react";
import RouteLayout from "../../../../Components/Layout/RouteLayout";
import bus from "./bus.png";
import { Button } from "@mui/material";
import { useNavigate } from "react-router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const ServiceBookingDetails = () => {
  const navigate = useNavigate();
  return (
    <RouteLayout>
      <div className="mb-5">
        <Button
          startIcon={<ArrowBackIcon />}
          variant="outlined"
          style={{ marginRight: "10px" }}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </div>
      <div className="flex justify-between mb-5">
        <div>
          <h3 className="text-[34] font-bold text-[#6E9170]">
            Service Details
          </h3>
        </div>
        <button className="bg-[#4B664C] text-white px-4 py-2 rounded-lg">
          Book Service
        </button>
      </div>
      <div className="p-6 bg-white rounded-lg shadow">
        <div className="mb-8 p-6 bg-[#F7FAF9] rounded-lg border">
          <h2 className="text-lg font-semibold text-[#6E9170] mb-4">
            Service Information
          </h2>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div className="flex justify-between">
              <span className="font-medium">Service Name:</span>
              <span>Fleets</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Total:</span>
              <span>40</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Total Unavailable:</span>
              <span>4</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Price Per Unit:</span>
              <span>45,000</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Total Available:</span>
              <span>36</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Status:</span>
              <span className="text-green-600">Active</span>
            </div>
          </div>
        </div>

        {/* Facilities Information Section */}
        <div className="mb-8 p-6 bg-[#F7FAF9] rounded-lg border">
          <h2 className="text-lg font-semibold text-[#6E9170] mb-4">
            Facilities Information
          </h2>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div className="flex justify-between">
              <span className="font-medium">Facility Name:</span>
              <span>Toyota Hiace 16-Seaters Bus</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Quantity:</span>
              <span>36</span>
            </div>
            <div className="flex justify-between col-span-2">
              <span className="font-medium">Description:</span>
              <span>
                Ideal for group travel, the Toyota Hiace 16-Seater Bus offers
                comfortable seating for up to 16 passengers.
              </span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Available Quantity:</span>
              <span>4</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Status:</span>
              <span className="text-green-600">Available</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Location:</span>
              <span>Lagos</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Booking Price:</span>
              <span>34,000</span>
            </div>
          </div>
          <div className="flex justify-between mt-4">
            {/* Images */}
            <div className="flex gap-2">
              <img src={bus} className="h-40 w-40 object-cover rounded-lg" />
              <img src={bus} className="h-40 w-40 object-cover rounded-lg" />
              <img src={bus} className="h-40 w-40 object-cover rounded-lg" />
              <img src={bus} className="h-40 w-40 object-cover rounded-lg" />
            </div>
          </div>
        </div>

        {/* Component Information Section */}
        <div className="mb-8 p-6 bg-[#F7FAF9] rounded-lg border">
          <h2 className="text-lg font-semibold text-[#6E9170] mb-4">
            Component Information
          </h2>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div className="flex justify-between">
              <span className="font-medium">Name:</span>
              <span>Driver</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Quantity:</span>
              <span>36</span>
            </div>
            <div className="flex justify-between col-span-2">
              <span className="font-medium">Description:</span>
              <span>Placeholder</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Status:</span>
              <span className="text-green-600">Active</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Location:</span>
              <span>Lagos</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Optional:</span>
              <span>Yes</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Optional Price:</span>
              <span>34,000</span>
            </div>
          </div>
        </div>

        {/* Book Service Button */}
        <div className="flex justify-end">
          <button className="bg-[#4B664C] text-white px-4 py-2 rounded-lg">
            Book Service
          </button>
        </div>
      </div>
    </RouteLayout>
  );
};

export default ServiceBookingDetails;
